
export default class ProductModel {
  constructor({ codProduct = null, 
                ref1 = '',
                ref2= '',
                idmanufacturer = null, 
                manufacturer = '',
                description = '',  
                dc = [],
                pvp = 0,
                gd = null,
                saleDiscount = 0,
                photo = ''               
              } = {}) {
    this.codProduct = codProduct;
    this.ref1 = ref1;
    this.ref2 = ref2;
    this.idmanufacturer = idmanufacturer;
    this.manufacturer = manufacturer;
    this.dc = dc;
    this.pvp = pvp;
    this.gd = gd;
    this.description = description;    
    this.saleDiscount = saleDiscount;
    this.photo = photo;
  }    
  static fromJson(data) {
    let dc = [];
    dc["1031"] = data.dc1031;
    dc["1033"] = data.dc1033;
    dc["1034"] = data.dc1034;
    dc["1156"] = data.dc1156;
    return new ProductModel({
      codProduct: data.codProduct,
      ref1: data.ref1,
      ref2: data.ref2,
      idmanufacturer: data.idmanufacturer,
      manufacturer: data.manufacturer,      
      description: data.description,
      dc: dc,
      pvp: data.pvp,
      gd: data.gd,
      saleDiscount: data.saleDiscount,
      photo: data.photo
    })
  }
}
